import { render, staticRenderFns } from "./coupon-detail.vue?vue&type=template&id=668ddc0e&scoped=true&"
import script from "./coupon-detail.vue?vue&type=script&lang=js&"
export * from "./coupon-detail.vue?vue&type=script&lang=js&"
import style0 from "./coupon-detail.vue?vue&type=style&index=0&id=668ddc0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ddc0e",
  null
  
)

export default component.exports